<template>
  <div class="discoverHeight">
    <!-- start, navegación mediante genero principal y secundario -->
    <div v-show="withFilters && genresMain.length > 0">
      <!-- start, aca agregamos componente para genero principal -->
      <div
        style="background-color: #393839; position: relative; display: flex"
        class="w-100 justify-around items-center ttu"
      >
        <!-- boton de navegacion izquierdo -->
        <div>
          <a
            style="margin-left: 10px; fill: white; cursor: pointer"
            v-on:click="genTranslate('genMain', 'left')"
          >
            <svg
              width="25"
              height="25"
              class="bi bi-caret-left"
              viewBox="0 0 16 16"
            >
              <path
                d="M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"
              />
            </svg>
          </a>
        </div>

        <div></div>

        <div class="container-scroll w-100">
          <div id="genMain" class="container-genbar">
            <!-- show genero principal TODOS -->
            <a
              class="genre-filter f6 link dim ph3 pv2 dib white mr2"
              :class="{
                'genre-filter-selected': genreFilter == '',
                pointer: genreFilter != '',
              }"
              @click="selectGenMain('')"
            >
              {{ $t("tracks.genres.all") }}
            </a>

            <!-- show genero principal -->
            <a
              v-show="genresMain.length > 0"
              class="genre-filter f6 link dim ph3 pv2 dib white mr2"
              v-for="genre in genresMain"
              :track-by="genre.id"
              :key="genre.id"
              :tabindex="genre.id"
              :class="{
                'genre-filter-selected': genreFilter == genre.id,
                pointer: genreFilter != genre.id,
              }"
              @click="selectGenMain(genre.id)"
              @blur="selectGenMainBlur($event)"
              @focus="selectGenMainFocus($event)"
            >
              {{ genre.name }}
            </a>
          </div>
        </div>

        <!-- boton de navegacion derecho -->
        <div>
          <a
            style="margin-right: 10px; fill: white; cursor: pointer"
            v-on:click="genTranslate('genMain', 'right')"
          >
            <svg
              width="25"
              height="25"
              class="bi bi-caret-right"
              viewBox="0 0 16 16"
            >
              <path
                d="M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"
              />
            </svg>
          </a>
        </div>
      </div>
      <!-- end, aca agregamos componente para genero principal -->

      <!-- start, aca agregamos componente para genero secundario -->
      <div
        style="background-color: black; position: relative; display: flex"
        class="w-100 justify-between items-center ttu black"
      >
        <!-- boton de navegacion izquierdo -->
        <div>
          <a
            style="fill: white; cursor: pointer"
            v-on:click="genTranslate('genSecon', 'left')"
          >
            <svg
              width="25"
              height="25"
              class="bi bi-caret-left"
              viewBox="0 0 16 16"
            >
              <path
                d="M10 12.796V3.204L4.519 8 10 12.796zm-.659.753-5.48-4.796a1 1 0 0 1 0-1.506l5.48-4.796A1 1 0 0 1 11 3.204v9.592a1 1 0 0 1-1.659.753z"
              />
            </svg>
          </a>
        </div>

        <div class="container-scroll w-100">
          <div id="genSecon" class="container-genbar">

            <!-- show genero secundario -->
            <a
              class="genre-filter f6 link dim ph3 pv2 dib white mr2"
              style="font-size: 0.775rem; min-width: 120px; text-align: center;"
              v-for="genre in genSeconByMain"
              :track-by="genre.id"
              :key="genre.id"
              :class="{
                'genre-filter-selected': genreFilter == genre.id,
                pointer: genreFilter != genre.id,
              }"
              @click="selectGenSecon(genre.id)"
            >
              {{ genre.name }}
            </a>
          </div>
        </div>

        <!-- boton de navegacion derecho -->
        <div>
          <a
            style="fill: white; cursor: pointer"
            v-on:click="genTranslate('genSecon', 'right')"
          >
            <svg
              width="25"
              height="25"
              class="bi bi-caret-right"
              viewBox="0 0 16 16"
            >
              <path
                d="M6 12.796V3.204L11.481 8 6 12.796zm.659.753 5.48-4.796a1 1 0 0 0 0-1.506L6.66 2.451C6.011 1.885 5 2.345 5 3.204v9.592a1 1 0 0 0 1.659.753z"
              />
            </svg>
          </a>
        </div>
      </div>
      <!-- end, aca agregamos componente para genero secundario -->
    </div>
    <!-- Filtro por texto -->
    <div class="w-100 mh3 w-mobile">
      <div class="search-wrapper w-third-l w-50-m w-100 block pointer z-1 relative bg-tertiary fr mt3">
        <button class="w-10-ns w-90 pointer btn1 dim b f5 fw4 " type="button" icon="search" @click="update"><font-awesome-icon class="search-left-icon " icon="search"/></button>
        <input class="pa2 input w-100 bg-transparent w-50-mobile"
                v-model="textToFilter"
                maxlength="255"
                @keyup.esc="clearFilters"
                @keyup.enter="update"
                :placeholder="$t('artists.search.placeholder')"/>
      </div>
    </div>
    <!-- Fin filtro por texto -->
    <!-- Leyenda de filtros -->
    <div class="filtersLabelsDiv">
      <span v-if="mainGenre.name" class="filtersLabels" @click="filterByMainGenreLabel">{{mainGenre.name}}</span>
      <span v-if="mainGenre.name && seconGenre.name"> / </span>
      <span v-if="seconGenre.name" class="filtersLabels" @click="removeSeconGenreLabel">{{seconGenre.name}}</span>
      <span v-if="(mainGenre.name || seconGenre.name) && filteredText"> / </span>
      <span v-if="filteredText" class="filtersLabels" @click="removeFilteredTextLabel">{{filteredText}}</span>
    </div>
    <!-- Fin leyenda de filtros -->
    <div id="discoverMainContent">
      <div id="artistsCarousel">
        <h2 class="p-2 carouselTitle">{{ $t("discover.carousels.artists") }}</h2>
        <div v-if="artists">
          <custom-carousel :loading="loading" :artists="artists" :textToFilter="textToFilter"/>
        </div>
        <div v-if="!artists" class="flex justify-center">
          <p>{{ $t("app.info.noResults") }}</p>
        </div>
      </div>
      <div id="tracksCarousel">
        <h2 class="p-2 carouselTitle">{{ $t("discover.carousels.tracks") }}</h2>
        <div v-if="allTracks">
          <custom-carousel :loading="loading" :allTracks="allTracks" :textToFilter="textToFilter"/>
        </div>
        <div v-if="!allTracks" class="flex justify-center">
          <p>{{ $t("app.info.noResults") }}</p>
        </div>
      </div>
      <div id="playlistsCarousel">
        <h2 class="p-2 carouselTitle">{{ $t("discover.carousels.playlists") }}</h2>
        <div v-if="playlists">
          <custom-carousel :loading="loading" :playlists="playlists" :textToFilter="textToFilter"/>
        </div>
        <div v-if="!playlists">
          <p>No se encontraron Playlists con ése género</p>
        </div>
      </div>
      <div id="recommendedPlaylistsCarousel">
        <h2 class="p-2 carouselTitle">{{ $t("discover.carousels.recommendedPlaylists") }}</h2>
        <div v-if="recommendedPlaylists">
          <custom-carousel :loading="loading" :recommendedPlaylists="recommendedPlaylists" :textToFilter="textToFilter"/>
        </div>
        <div v-if="!recommendedPlaylists">
          <p>No se encontraron Playlists recomendadas con ése género</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import infiniteScroll from 'vue-infinite-scroll'
import {Carousel, Slide} from 'vue-carousel'
import CustomCarousel from '../carousel/CustomCarousel.vue'
import debounce from 'debounce'

export default {
  name: 'new-discover',
  props: {
    withFilters: {
      default: true
    },
    withPagination: {
      default: true
    },
    loading: {
      required: false
    },
    showGenMain: {
      default: true
    },
    showGenSecon: {
      default: true
    },
    profileTracks: {
      default: false
    }
  },
  components: {
    ClipLoader,
    Carousel,
    Slide,
    CustomCarousel
  },
  directives: {
    infiniteScroll
  },
  data () {
    return {
      color: '#808080',
      size1: '100px',
      size2: '30px',
      disablePagination: false,
      genSeconByMain: [],
      genMainTranslatePosition: 0,
      genSeconTranslatePosition: 0,
      hasSelectedGenMain: false,
      hasSelectedGenSecon: false,
      genMainLastEvent: { // emazzu, para mantener el color de padre seleccionado
        event: null,
        background: null,
        color: null
      },
      busy: false,
      translatePosition: null,
      textToFilter: '',
      isUpdate: false,
      discoverSelectedGenre: null,
      mainGenre: {
        name: null,
        id: null
      },
      seconGenre: {
        name: null,
        id: null
      },
      filteredText: null
    }
  },
  /*
  watch: {
    textToFilter: function (newText, oldText) {
      if ((!newText || newText === undefined || newText === '')) {
        this.selectTrackByFilter(this.discoverSelectedGenre)
        this.selectArtistByFilter(this.discoverSelectedGenre)
        // this.selectPlaylistByFilter()
        this.filteredText = null
      }
    }
  },
  */
  created () {
    this.discoverSelectedGenre = 0
    this.disablePagination = !this.withPagination
    if (this.withFilters) {
      this.getGenresMain(true)
      this.setGenreFilter(0)
      this.setArtistGenreFilter(0)
      this.setPlaylistGenreFilter(0)
    }
    this.selectTrackByFilter()
    this.selectArtistByFilter()
    this.selectPlaylistByFilter()
  },

  mounted () {
    window.scrollTo(0, 0)
  },

  methods: {
    ...mapActions('track', [
      'getGenresMain',
      'setGenreFilter',
      'getAll',
      'setFrom'
    ]),
    ...mapActions('player', ['setPlaylist']),
    ...mapActions('artist', [
      'getAllArtists',
      'setArtistGenreFilter',
      'setPageFrom'
    ]),
    ...mapActions('playlist', [
      'getAllPlaylist',
      'setPlaylistFrom',
      'setPlaylistGenreFilter',
      'getAllRecommendedPlaylist'
    ]),
    ...mapMutations('track', [
      'setDiscoverMainGenre',
      'setDiscoverSeconGenre'
    ]),

    clearFilters () {
      this.textToFilter = ''
      this.filteredText = null
    },

    update: debounce(function (e) {
      if (this.textToFilter !== '') {
        this.filteredText = this.textToFilter
        this.selectTrackByFilter(this.discoverSelectedGenre, this.textToFilter)
        this.selectArtistByFilter(this.discoverSelectedGenre, this.textToFilter)
        this.selectPlaylistByFilter(this.discoverSelectedGenre, this.textToFilter)
        this.textToFilter = ''
      } else {
        this.selectTrackByFilter(this.discoverSelectedGenre, null)
        this.selectArtistByFilter(this.discoverSelectedGenre, null)
        this.filteredText = null
      }
    }, 1000, true),

    // emazzu, start, para mantener el color de seleccion en el genero padre
    selectGenMainBlur (event) {
      this.genMainLastEvent = {
        background: event.target.style.background,
        color: event.target.style.color,
        event: event
      }
      event.target.style.background = '#E6007E'
      event.target.style.color = 'white'
    },

    selectGenMainFocus (event) {
      if (this.genMainLastEvent.event === null) {
        return
      }

      this.genMainLastEvent.event.target.style.background = this.genMainLastEvent.background
      this.genMainLastEvent.event.target.style.color = this.genMainLastEvent.color
    },
    // emazzu, end, para mantener el color de seleccion en el genero padre

    // emazzu, cuando se hace clic en el genero primario
    selectGenMain (selectedId) {
      if (selectedId === '') {
        this.genMainLastEvent.event.target.style.background = ''
        this.genMainLastEvent.event.target.style.color = ''
      }
      selectedId = selectedId || 0
      // emazzu, filter todos los tracks que corresponden al genero primario
      if (this.withFilters && selectedId !== this.genreFilter) {
        this.selectTrackByFilter(selectedId)
        this.selectArtistByFilter(selectedId)
        this.selectPlaylistByFilter(selectedId)
      }

      this.discoverSelectedGenre = selectedId

      // emazzu, find genero primario seleccionado
      var found = this.genresMain.find((ele) => ele.id === selectedId)
      if (selectedId !== 0) {
        this.mainGenre = found
        this.setDiscoverMainGenre(found)
      } else {
        this.mainGenre = {
          name: null,
          id: null
        }
        this.setDiscoverMainGenre({ name: null, id: null })
      }
      this.seconGenre = {
        name: null,
        id: null
      }
      this.setDiscoverSeconGenre({ name: null, id: null })
      this.textToFilter = ''
      this.filteredText = null

      // emazzu, si encontro, que siempre va a encontrar, menos si selecciona TODOS
      if (typeof found !== 'undefined') {
        this.genSeconByMain = found.children.sort(function (a, b) {
          if (a.name > b.name) {
            return 1
          }
          if (a.name < b.name) {
            return -1
          }
          // a must be equal to b
          return 0
        })
      } else {
        this.genSeconByMain = []
      }

      // flags
      this.hasSelectedGenMain = true
      this.hasSelectedGenSecon = false

      // flag, si selecciono TODOS, vuelvo para atras uno de los flag
      if (selectedId === '') {
        this.hasSelectedGenMain = false
      }

      // los 2 filtros siempre visibles, dejamos los flags x las dudas
      this.showGenMain = true
      this.showGenSecon = true
      // Resetea lo posicion del genSecon
      var style = 'transform: translateX( 0px)'
      this.$el.querySelector('#genSecon').style = style
      this.genSeconTranslatePosition = 0
      this.translatePosition = 0

      return null
    },

    selectGenSecon (selectedId) {
      // emazzu, filter todos los tracks que corresponden al genero primario
      if (this.withFilters && selectedId !== this.genreFilter) {
        this.selectTrackByFilter(selectedId)
        this.selectArtistByFilter(selectedId)
        this.selectPlaylistByFilter(selectedId)
      }
      this.discoverSelectedGenre = selectedId
      this.textToFilter = ''
      this.filteredText = null

      // flags
      this.hasSelectedGenMain = true
      this.hasSelectedGenSecon = true

      // los 2 filtros siempre visibles, dejamos los flags x las dudas
      this.showGenMain = true
      this.showGenSecon = true
      var found = this.genSeconByMain.find((ele) => ele.id === selectedId)
      this.seconGenre = found
      this.setDiscoverSeconGenre(found)

      return null
    },
    selectTrackByFilter (selectedId = 0, textToFilter = null) {
      this.setGenreFilter(selectedId)
      this.setFrom(0)
      this.getAll(textToFilter)
    },
    selectArtistByFilter (selectedId = 0, textToFilter = null) {
      this.setArtistGenreFilter(selectedId)
      this.setPageFrom(0)
      this.getAllArtists(textToFilter)
    },
    selectPlaylistByFilter (selectedId = 0, textToFilter = null) {
      this.setPlaylistGenreFilter(selectedId)
      this.setPlaylistFrom(0)
      this.getAllPlaylist(textToFilter).catch((e) => {
        this.$toasted.show(this.error.message, {type: 'error'})
      })
      this.getAllRecommendedPlaylist(textToFilter).catch((e) => {
        this.$toasted.show(this.error.message, {type: 'error'})
      })
    },

    // emazzu, transition genero principal y secundario
    genTranslate (element, arrow) {
      const transitionValue = 120

      if (element === 'genMain') {
        this.genMainTranslatePosition += (arrow === 'left' ? transitionValue : transitionValue * -1)
        this.translatePosition = this.genMainTranslatePosition
      }

      if (element === 'genSecon') {
        this.genSeconTranslatePosition += (arrow === 'left' ? transitionValue : transitionValue * -1)
        this.translatePosition = this.genSeconTranslatePosition
      }

      if (this.translatePosition >= 120) {
        this.translatePosition = 0
        this.genMainTranslatePosition = 0
        this.genSeconTranslatePosition = 0
      }
      if (this.translatePosition <= -(120 * (this.genresMain.length - 1)) && element === 'genMain') {
        this.translatePosition = -(120 * (this.genresMain.length - 1))
        this.genMainTranslatePosition = -(120 * (this.genresMain.length - 1))
        this.genSeconTranslatePosition = 0
      }
      if (this.translatePosition <= -(120 * (this.genSeconByMain.length - 1)) && element === 'genSecon') {
        this.translatePosition = -(120 * (this.genSeconByMain.length - 1))
        this.genMainTranslatePosition = 0
        this.genSeconTranslatePosition = -(120 * (this.genSeconByMain.length - 1))
      }
      var style = 'transform: translateX(' + this.translatePosition.toString() + 'px' + ')'
      this.$el.querySelector('#' + element).style = style
    },

    filterByMainGenreLabel () {
      this.genMainLastEvent.event.target.style.background = ''
      this.genMainLastEvent.event.target.style.color = ''
      this.mainGenre = {
        name: null,
        id: null
      }
      this.seconGenre = {
        name: null,
        id: null
      }
      this.setDiscoverMainGenre({ name: null, id: null })
      this.setDiscoverSeconGenre({ name: null, id: null })
      this.genSeconByMain = []
      let text = this.filteredText ? this.filteredText : null
      this.discoverSelectedGenre = 0
      this.selectTrackByFilter(0, text)
      this.selectArtistByFilter(0, text)
      this.selectPlaylistByFilter(0, text)
    },
    removeSeconGenreLabel () {
      this.seconGenre = {
        name: null,
        id: null
      }
      this.setDiscoverSeconGenre({ name: null, id: null })
      let text = this.filteredText ? this.filteredText : null
      this.discoverSelectedGenre = this.mainGenre.id
      this.selectTrackByFilter(this.mainGenre.id, text)
      this.selectArtistByFilter(this.mainGenre.id, text)
      this.selectPlaylistByFilter(this.mainGenre.id, text)
    },
    removeFilteredTextLabel () {
      this.clearFilters()
      this.selectTrackByFilter(this.discoverSelectedGenre)
      this.selectArtistByFilter(this.discoverSelectedGenre)
      this.selectPlaylistByFilter(this.discoverSelectedGenre)
    }
  },
  computed: {
    ...mapGetters('player', ['currentTrack']),
    ...mapGetters('track', [
      'allTracks',
      'genresMain',
      'genreFilter',
      'noMoreResults'
    ]),
    ...mapGetters('artist', [
      'artists'
    ]),
    ...mapGetters('playlist', [
      'playlists',
      'recommendedPlaylists'
    ])
  }
}
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

#discoverMainContent {
  padding-top: 30px;
}

.VueCarousel-inner{
  max-width: 20% !important;
}

.carouselTitle {
  font-size: 14px;
  text-transform: uppercase;
}

.track-playing {
    background-color: $primary-color !important;
  }

.track-list {
  max-height: $main-height;
  height: min-content;
}

.genre-filter {
  -webkit-user-select: none; /* Safari 3.1+ */
  -moz-user-select: none; /* Firefox 2+ */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Standard syntax */
  white-space: nowrap;
}

.genre-filter-selected {
  background-color: $accent-color;
  color: white;
}

.search-wrapper{
  max-width: 25rem;
}

.btn1{
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  background-color: #272727;
  color: white;
  height: 35px;
  border-width: 0px;
  border-radius: 35px;
}

.search-left-icon {
  top: 15px;
  left: 15px;
}

.search-right-icon {
  top: 15px;
  right: 15px;
}

input {
  padding-left: 8px;
  border: solid black 1px;
  border-radius: 5px;
  line-height: 1px;
  max-width: 19.75rem;
}

.p-2 {
  padding: 0.5rem;
}

.discoverHeight {
  height: 260vh;
}

.filtersLabelsDiv {
  position: relative;
  top: 25px;
  padding-left: 20px;
}
.filtersLabels {
  cursor: pointer;
  padding: 2px 10px;
  border: 1px solid #E6007E;
  border-radius: 100px;
  text-transform: uppercase;
}
.filtersLabels:hover {
  border: 1px solid #272727;
  background-color: #E6007E;
  font-weight: bold;
  color: #272727;
}

@media (min-width: 320px) {
  .item-container :hover {
    background-color: lightgray !important;
  }

  .track-list {
    max-height: $main-height;
    height: min-content;
  }

  .genre-filter {
    -webkit-user-select: none; /* Safari 3.1+ */
    -moz-user-select: none; /* Firefox 2+ */
    -ms-user-select: none; /* IE 10+ */
    user-select: none; /* Standard syntax */
    white-space: nowrap;
  }

  .genre-filter-selected {
    background-color: darkgray;
    color: black;
  }

  @media (min-width: 769px) {
    .item-container :hover {
      background-color: $primary-color;
    }
    .item-container {
      height: 3rem;
    }
  }

  @media (max-width: 769px) {
    .track-list-header {
      display: none;
    }
    .track-list {
      display: flex;
      flex-wrap: wrap;
    }
    .track-container {
      height: 6rem;
      width: 45%;
      margin: 2.5%;
    }
    .genre-filter {
      padding: 4px;
    }
  }

  @media (max-width: 600px) {
    .track-container {
      width: 95%;
    }
    .search-wrapper{
      max-width: 20rem;
    }
    .w-mobile{
      max-width: 20rem;
    }
    .btn1{
      max-width: 2rem;
    }
    .w-50-mobile{
      width: 80%;
    }
  }

  .container-scroll {
    overflow-x: scroll;
    scroll-behavior: smooth;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
  }

  .container-genbar {
    display: flex;
    transition: all 0.3s ease-out;
  }

    // como personalizar el scrolling
    // https://css-tricks.com/custom-scrollbars-in-webkit/
    //
  .container-scroll::-webkit-scrollbar {
    display: none;
    scroll-behavior: smooth;
    height: 7px;
  }
}

@media (min-width: 1441px) {
  .track-list {
    padding-left: 10rem;
    padding-right: 10rem;
  }
  .discoverHeight {
    height: 210vh;
  }
}

@media (max-width: 480px) {
  .carouselTitle {
    text-align: center;
  }
  #discoverMainContent {
    padding-top: 50px;
  }
  .discoverHeight {
    height: 170vh;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/discover/NewDiscover.vue